<div class="space-y-6">
  <!-- Product Details Section -->
  @if (isProductLoading) {
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5">
    <div class="flex items-center justify-center py-12">
      <app-progress-loader></app-progress-loader>
    </div>
  </div>
  } @else if (product) {
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <div class="px-5 py-3.5 border-b border-slate-200 dark:border-slate-700">
      <h2 class="text-xs font-bold uppercase tracking-widest text-primary-800 dark:text-primary-400">Product Details</h2>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Left: Product Information -->
        <div class="space-y-4">
          <h3 class="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4 pb-2 border-b border-slate-100 dark:border-slate-700/50">Product Information</h3>
          <div class="grid grid-cols-2 gap-x-8 gap-y-4">
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Product Name</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.name || '—' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Product Code</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.code || '—' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Category</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.category?.name || '—' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Status</p>
              @if (product.isActive === true) {
              <span class="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900 uppercase tracking-widest leading-none">Active</span>
              } @else {
              <span class="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold bg-slate-50 dark:bg-slate-800/60 text-slate-400 border border-slate-100 dark:border-slate-700/50 uppercase tracking-widest leading-none">Inactive</span>
              }
            </div>
            <div class="col-span-2">
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Created Date</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.createdAt ? (product.createdAt | date:'dd MMM yyyy') : '—' }}</p>
            </div>
          </div>
        </div>

        <!-- Right: Loan Parameters -->
        <div class="space-y-4">
          <h3 class="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-4 pb-2 border-b border-slate-100 dark:border-slate-700/50">Loan Parameters</h3>
          <div class="grid grid-cols-2 gap-x-8 gap-y-4">
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Amount Range</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">₵{{ product.minAmount | number:'1.0-0' }} – ₵{{ product.maxAmount | number:'1.0-0' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Max Tenure</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.maxTenure || '—' }} Months</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Disbursement</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.disbursementType || '—' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Repayment Mode</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.repaymentMode || '—' }}</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Age Range</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.minAgeLimit }} – {{ product.maxAgeLimit }} Years</p>
            </div>
            <div>
              <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Credit Score</p>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">{{ product.minCreditScore }} – {{ product.maxCreditScore }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Rates Row: full width below both columns -->
      <div class="border-t border-slate-100 dark:border-slate-700/50 pt-4 mt-2">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-4">
          <div>
            <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Interest Rate</p>
            @if (product.interestRate != null) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-400 border border-blue-100 dark:border-blue-900 uppercase tracking-widest leading-none">{{ product.interestRate }}%</span>
            } @else {
            <p class="text-sm font-semibold text-slate-900 dark:text-white">—</p>
            }
          </div>
          <div>
            <p class="text-xxxs text-slate-400 uppercase font-bold tracking-widest mb-1 leading-none">Processing Fee Rate</p>
            @if ((product.processingFeeRate ?? product.processingFee) != null) {
            <span class="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold bg-violet-50 dark:bg-violet-950/40 text-violet-700 dark:text-violet-400 border border-violet-100 dark:border-violet-900 uppercase tracking-widest leading-none">{{ product.processingFeeRate ?? product.processingFee }}%</span>
            } @else {
            <p class="text-sm font-semibold text-slate-900 dark:text-white">—</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5">
    <div class="flex flex-col items-center justify-center py-16 text-center">
      <div class="w-12 h-12 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mb-4 border border-slate-100 dark:border-slate-700/50">
        <span class="text-xl text-slate-300">!</span>
      </div>
      <h3 class="text-sm font-bold text-slate-900 dark:text-white">Product Details Unavailable</h3>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">Unable to load product information. Please try refreshing the page.</p>
    </div>
  </div>
  }

  <!-- Stats Cards -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <app-product-analysis [title]="'Applications'" [today]="''" [total]="productDetailsStore.totalApplications()"
      [text]="''" [icon]="_images.shareIcon">
    </app-product-analysis>

    <app-product-analysis [title]="'Repayment Overdue'" [today]="''" [total]="productDetailsStore.totalRepaymentDue()"
      [text]="''" [icon]="_images.overdueIcon" [accentColor]="'#F59E0B'">
    </app-product-analysis>

    <app-product-analysis [title]="'Denied'" [today]="''" [total]="productDetailsStore.totalDenied()" [text]="''"
      [icon]="_images.deniedIcon" [accentColor]="'#E11D48'">
    </app-product-analysis>
  </div>

  <!-- Search and Filter -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
    <div class="w-full sm:w-96">
      <app-search [placeholder]="'Search by applicant name'"></app-search>
    </div>
    <div class="flex items-center gap-2">
      <app-filters
        (onSaveEvent)="filterLoans($event)"
        (resetClickEvent)="resetLoanFilters()">
      </app-filters>
      <button (click)="getPaginatedProductLoans(productId)"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:text-slate-100 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 transition-colors text-xs font-semibold"
        title="Refresh">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>

        <span>Refresh</span>
      </button>
    </div>
  </div>

  <!-- Table Container -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <!-- Table Header -->
    <div
      class="grid grid-cols-12 gap-x-3 px-5 py-2.5 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700 text-xs font-semibold text-slate-400 leading-none">
      <div class="col-span-1 text-left">Date</div>
      <div class="col-span-2 text-left">Applicant</div>
      <div class="col-span-2 text-left">ID / Card</div>
      <div class="col-span-1 text-left">Applied</div>
      <div class="col-span-1 text-left">Principal</div>
      <div class="col-span-1 text-left">Interest</div>
      <div class="col-span-1 text-left">Repay</div>
      <div class="col-span-1 text-left">Tenure</div>
      <div class="col-span-1 text-left">Status</div>
      <div class="col-span-1 text-center">Actions</div>
    </div>

    <!-- Table Body -->
    <div class="overflow-y-auto max-h-[400px]">
      @if (isLoanServiceLoading) {
      <div class="flex items-center justify-center py-20">
        <app-progress-loader></app-progress-loader>
      </div>
      } @else {
      @if (loans.length > 0) {
      @for (loan of loans; track $index) {
      <app-single-product-overview-table [productId]="productId" [loan]="loan" (onView)="viewApplication($event)"
        (onApprove)="handleAction($event, 'APPROVE')" (onReject)="handleAction($event, 'REJECT')"
        (onCounter)="handleAction($event, 'COUNTER')" (onDisburse)="handleAction($event, 'DISBURSE')">
      </app-single-product-overview-table>
      }
      } @else {
      <div class="flex flex-col items-center justify-center py-24 text-center px-4">
        <div class="w-12 h-12 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mx-auto mb-4 border border-slate-100 dark:border-slate-700/50">
          <span class="text-xl text-slate-300">!</span>
        </div>
        <h3 class="text-sm font-bold text-slate-900 dark:text-white">No Loan Applications</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">There are no loan applications for this product yet.</p>
      </div>
      }
      }
    </div>

    <!-- Pagination -->
    @if (!isLoanServiceLoading && loans.length > 0) {
    <app-pagination [totalItems]="loanPagination?.meta?.total || 0" [itemsPerPage]="loanQueryParams.perPage || 10"
      [currentPage]="loanQueryParams.page || 1" (pageChange)="onPageChange($event)">
    </app-pagination>
    }
  </div>

  <!-- Modal Overlay -->
  @if (showModal && currentLoan) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 backdrop-blur-sm p-4">
    <div class="w-full max-w-4xl bg-white dark:bg-slate-800 rounded-2xl shadow-2xl flex flex-col overflow-hidden" style="max-height: 90vh;" (click)="$event.stopPropagation()">
      <!-- Modal Header -->
      <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex-shrink-0">
        <div>
          <p class="text-xs font-semibold text-slate-400">Loan Application</p>
          <h2 class="text-lg font-bold text-slate-900 dark:text-white mt-0.5">#{{ currentLoan.reference ?? currentLoan.id?.substring(0, 8)?.toUpperCase() }}</h2>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-[10px] font-bold px-2.5 py-1 rounded border uppercase tracking-wide" [class]="currentLoan.status | loanStatusStyle">
            {{ currentLoan.status | loanStatusLabel }}
          </span>
          @if (currentLoan.status === 'PENDING_APPROVAL' && !currentLoan.counterOffer) {
          @if (permissionService.canApprove()) {
          <button (click)="handleAction(currentLoan, 'APPROVE')" class="px-3 py-1.5 text-xs font-semibold text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-900 rounded-lg hover:bg-emerald-100 dark:hover:bg-emerald-950/60 transition-colors">Approve</button>
          <button (click)="handleAction(currentLoan, 'REJECT')" class="px-3 py-1.5 text-xs font-semibold text-rose-700 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900 rounded-lg hover:bg-rose-100 dark:hover:bg-rose-950/60 transition-colors">Reject</button>
          @if (currentLoan.requiresAcceptance !== false) {
          <button (click)="handleAction(currentLoan, 'COUNTER')" class="px-3 py-1.5 text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900 rounded-lg hover:bg-amber-100 dark:hover:bg-amber-950/60 transition-colors">Counter</button>
          }
          }
          }
          @if (currentLoan.status === 'ACCEPTED' && permissionService.canApprove()) {
          <button (click)="handleAction(currentLoan, 'APPROVE')" class="px-3 py-1.5 text-xs font-semibold text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-900 rounded-lg hover:bg-emerald-100 dark:hover:bg-emerald-950/60 transition-colors">Approve</button>
          }
          @if ((currentLoan.status === 'APPROVED' || currentLoan.status === 'PENDING_DISBURSEMENT') && permissionService.canDisburse()) {
          <button (click)="handleAction(currentLoan, 'DISBURSE')" class="px-3 py-1.5 text-xs font-semibold text-blue-700 dark:text-blue-400 bg-blue-50 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-900 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-950/60 transition-colors">Disburse</button>
          }
          <button (click)="closeModal()" class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 transition-colors">
            <svg class="w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Modal Content -->
      <div class="flex-1 overflow-y-auto">
        <app-view-new-application [loanInfo]="currentLoan" [showHeader]="false" (onClose)="closeModal()"></app-view-new-application>
      </div>
    </div>
    <div class="absolute inset-0 -z-10" (click)="closeModal()"></div>
  </div>
  }

  <!-- Approve Confirmation Dialog -->
  @if (showApproveDialog) {
  <app-confirmation-dialog
    [title]="'Approve Loan Application'"
    [message]="'Are you sure you want to approve this loan application?'"
    [confirmText]="'Approve'"
    [cancelText]="'Cancel'"
    [type]="'info'"
    (onConfirm)="confirmApprove()"
    (onCancel)="cancelApprove()">
  </app-confirmation-dialog>
  }

  <!-- Reject Dialog -->
  @if (showRejectDialog) {
  <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300 flex items-center justify-center z-50 p-4">
    <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-300" (click)="$event.stopPropagation()">
      <div class="flex items-center gap-3 px-5 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-rose-50/50">
        <div class="w-9 h-9 rounded-full flex items-center justify-center bg-rose-100 flex-shrink-0">
          <svg class="w-4 h-4 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-bold text-slate-900 dark:text-white">Reject Loan Application</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Please provide a reason for rejecting this application.</p>
        </div>
      </div>
      <div class="p-5">
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Rejection Reason <span class="text-error">*</span></label>
        <textarea [(ngModel)]="rejectionReason" rows="4" placeholder="Enter rejection reason..."
          class="w-full px-3 py-2.5 text-sm border border-slate-200 dark:border-slate-700 rounded-lg focus:outline-none focus:ring-1 focus:ring-rose-400 focus:border-rose-400 resize-none text-slate-700 dark:text-slate-300 placeholder-slate-400">
        </textarea>
      </div>
      <div class="bg-slate-50 dark:bg-slate-800/60 px-5 py-3.5 flex items-center justify-end gap-2 border-t border-slate-100 dark:border-slate-700/50">
        <button (click)="cancelReject()"
          class="px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
          Cancel
        </button>
        <button (click)="confirmReject()" [disabled]="!rejectionReason.trim()"
          class="px-4 py-2 text-xs font-semibold text-white bg-rose-600 rounded-lg hover:bg-rose-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Reject Application
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Counter Offer Dialog -->
  @if (showCounterDialog) {
  <div class="fixed inset-0 bg-slate-900/40 backdrop-blur-md animate-in fade-in duration-300 flex items-center justify-center z-50 p-4">
    <div class="bg-white dark:bg-slate-800 rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-300" (click)="$event.stopPropagation()">
      <div class="flex items-center gap-3 px-5 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-amber-50/50">
        <div class="w-9 h-9 rounded-full flex items-center justify-center bg-amber-100 flex-shrink-0">
          <svg class="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
          </svg>
        </div>
        <div>
          <h3 class="text-sm font-bold text-slate-900 dark:text-white">Counter Offer</h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">Propose a revised amount and tenure for this loan application.</p>
        </div>
      </div>
      <div class="p-5 space-y-4">
        <div>
          <label class="text-xs font-semibold text-slate-600 dark:text-slate-400 block mb-1.5">Amount (₵) <span class="text-error">*</span></label>
          <input type="number" [(ngModel)]="counterForm.amount" min="0" placeholder="Enter counter amount"
            class="w-full h-12 px-4 text-sm border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 text-slate-900 dark:text-white placeholder-slate-400" />
        </div>
        <div>
          <label class="text-xs font-semibold text-slate-600 dark:text-slate-400 block mb-1.5">Tenure (months) <span class="text-error">*</span></label>
          <input type="number" [(ngModel)]="counterForm.tenure" min="1" placeholder="Enter tenure in months"
            class="w-full h-12 px-4 text-sm border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 text-slate-900 dark:text-white placeholder-slate-400" />
        </div>
        <div>
          <label class="text-xs font-semibold text-slate-600 dark:text-slate-400 block mb-1.5">Comment</label>
          <textarea [(ngModel)]="counterForm.comment" rows="3" placeholder="Optional comment..."
            class="w-full px-4 py-3 text-sm border border-gray-300 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 resize-none text-slate-900 dark:text-white placeholder-slate-400">
          </textarea>
        </div>
      </div>
      <div class="bg-slate-50 dark:bg-slate-800/60 px-5 py-3.5 flex items-center justify-end gap-2 border-t border-slate-100 dark:border-slate-700/50">
        <button (click)="cancelCounter()"
          class="px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
          Cancel
        </button>
        <button (click)="confirmCounter()" [disabled]="!counterForm.amount || !counterForm.tenure"
          class="px-4 py-2 text-xs font-semibold text-white bg-amber-600 rounded-lg hover:bg-amber-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Submit Counter
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Disburse Confirmation Dialog -->
  @if (showDisburseDialog) {
  <app-confirmation-dialog
    [title]="'Disburse Loan'"
    [message]="'Are you sure you want to disburse this loan? Funds will be released to the applicant.'"
    [confirmText]="'Disburse'"
    [cancelText]="'Cancel'"
    [type]="'info'"
    (onConfirm)="confirmDisburse()"
    (onCancel)="cancelDisburse()">
  </app-confirmation-dialog>
  }
</div>